export default __webpack_public_path__ + "static/media/mobile_banner.6aa00198.png";